import React, {useState, useEffect} from 'react';
import {useDish} from "../../../utils/contexts/dish-context";
import SubTitle from "../../UI/Text/SubTitle";
import Button from "../../UI/Button";
import {doPutAiFeedback} from "../../../logic/dish";
import {useApi} from "../../../utils/hooks/api";
import Loading from "../../UI/Loading";
import {useTranslation} from "react-i18next";

const AiResponse = () => {
    const {t, i18n} = useTranslation();
    const {dish, setDish, openDishesModal} = useDish();
    const {call, loading} = useApi();
    const [aiFeedback, setAiFeedback] = useState('');

    useEffect(() => {
        if (dish) {
            setAiFeedback(dish.ai_feedback || '');
        }
    }, [dish]);

    if (!dish || (!dish.ai_response && !dish.ai_feedback)) {
        return null;
    }

    const {text, missing_tokens, ambiguity} = dish.ai_response || {};

    const handleSaveFeedback = async () => {
        await call(
            () => doPutAiFeedback(dish.id, aiFeedback, i18n.language),
            (res) => {
                setDish({...dish, ai_feedback: aiFeedback});
            }
        );
    };

    return (
        <div className="mt-4 p-4 border rounded shadow-sm bg-white mb-4">
            <SubTitle className="mb-2">AI Response</SubTitle>
            {dish.ai_response && (
                <>
                    <div className="mb-2">
                        <span className="font-bold">text:</span> {text}
                    </div>
                    <div className="mb-2">
                        <span className="font-bold">missing tokens:</span> {Array.isArray(missing_tokens) ? missing_tokens.join(', ') : missing_tokens}
                    </div>
                    <div className="mb-4">
                        <span className="font-bold">ambiguity:</span> {ambiguity}
                    </div>
                </>
            )}

            <div className="mt-4 flex flex-col gap-2">
                <label htmlFor="ai_feedback" className="font-bold">{t('calculate_impact.ai_feedback')}:</label>
                <textarea
                    id="ai_feedback"
                    className="w-full p-2 border rounded bg-black bg-opacity-5 outline-none focus:border-mcia_orange"
                    rows="3"
                    value={aiFeedback}
                    onChange={(e) => setAiFeedback(e.target.value)}
                    placeholder={t('calculate_impact.ai_feedback_placeholder')}
                />
                {loading ? (
                    <Loading label={t('calculate_impact.saving_feedback')}/>
                ) : (
                    <Button onClick={handleSaveFeedback} className="w-max">
                        {t('calculate_impact.save_feedback')}
                    </Button>
                )}
            </div>

            <div className="mt-6">
                <Button onClick={openDishesModal}>
                    Open Dishes
                </Button>
            </div>
        </div>
    );
};

export default AiResponse;
